export var Category;
(function (Category) {
    Category["MANDATORY"] = "mandatory";
    Category["FUNCTIONAL"] = "functional";
    Category["TARGETING"] = "targeting";
    Category["PERFORMANCE"] = "performance";
})(Category || (Category = {}));
export function isMandatory(category) {
    return Category.MANDATORY === category;
}
